import { seoTheme } from "@boseo/shared/themes";

const theme = {
    ...seoTheme,
};

export default theme;
